import * as React from 'react';
import { Button } from 'reactstrap';

const UIButton = Button;

export default UIButton;